export class DarkOverlayMapType implements google.maps.MapType {
  public tileSize: google.maps.Size;
  public maxZoom: number = 21;
  public minZoom: number = 0;
  public name: string = 'Dark Overlay';
  public alt: string = '';
  public projection: google.maps.Projection = null;
  public radius: number;

  private opacity: number = 0.75;

  constructor(tileSize: google.maps.Size = new google.maps.Size(256, 256)) {
    this.tileSize = tileSize;
  }

  /**
   * Returns a tile for the given tile coordinate and zoom level.
   * Creates a div element with black background and 0.75 opacity.
   */
  getTile(tileCoord: google.maps.Point, zoom: number, ownerDocument: Document): HTMLDivElement {
    const div = ownerDocument.createElement('div');
    div.className = 'dark-overlay-tile';

    // Set the size to match the tile size
    div.style.width = `${this.tileSize.width}px`;
    div.style.height = `${this.tileSize.height}px`;

    // Set black background with 0.75 opacity
    div.style.backgroundColor = '#000000';
    div.style.opacity = this.getActualOpacity().toString();

    // Remove border and ensure clean appearance
    div.style.border = '0px';
    div.style.margin = '0px';
    div.style.padding = '0px';

    // Ensure the div doesn't interfere with map interactions
    div.style.pointerEvents = 'none';

    // Optional: Add tile coordinate info for debugging (uncomment if needed)
    // div.innerHTML = `${zoom}/${tileCoord.x}/${tileCoord.y}`;
    // div.style.color = 'white';
    // div.style.fontSize = '10px';
    // div.style.textAlign = 'center';
    // div.style.lineHeight = `${this.tileSize.height}px`;

    return div;
  }

  /**
   * Releases the given tile, allowing it to be garbage collected.
   */
  releaseTile(tile: Element): void {
    // Clean up any resources if needed
    if (tile && tile.parentNode) {
      tile.parentNode.removeChild(tile);
    }
  }

  setOpacity(opacity: number) {
    this.opacity = opacity;
    document.querySelectorAll('.dark-overlay-tile').forEach(tile => {
      (tile as HTMLElement).style.opacity = this.getActualOpacity().toString();
    });
  }

  private getActualOpacity(): number {
    return 1 - this.opacity;
  }
}
